var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSuccessResultBadge = function SvgSuccessResultBadge(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 40,
    cy: 40.5,
    r: 40,
    fill: "#008850"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.08,
    cx: 40,
    cy: 40.5,
    r: 36,
    fill: "#008850"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3768 32.3134L50.0797 29.0068C50.0248 28.9519 49.9597 28.9082 49.8879 28.8785C49.8162 28.8487 49.7393 28.8334 49.6616 28.8334C49.584 28.8334 49.5071 28.8487 49.4353 28.8785C49.3636 28.9082 49.2984 28.9519 49.2436 29.0068L35.3182 42.9417C35.2634 42.9967 35.1982 43.0403 35.1265 43.07C35.0547 43.0998 34.9778 43.1151 34.9002 43.1151C34.8225 43.1151 34.7456 43.0998 34.6739 43.07C34.6021 43.0403 34.537 42.9967 34.4821 42.9417L31.185 39.6351C31.1301 39.5801 31.065 39.5365 30.9933 39.5067C30.9215 39.4769 30.8446 39.4616 30.7669 39.4616C30.6893 39.4616 30.6124 39.4769 30.5406 39.5067C30.4689 39.5365 30.4038 39.5801 30.3489 39.6351L27.0518 42.9417C26.9411 43.0524 26.8789 43.2025 26.8789 43.3591C26.8789 43.5157 26.9411 43.6658 27.0518 43.7766L34.4821 51.2081C34.537 51.2631 34.6021 51.3067 34.6739 51.3365C34.7456 51.3662 34.8225 51.3816 34.9002 51.3816C34.9778 51.3816 35.0547 51.3662 35.1265 51.3365C35.1982 51.3067 35.2634 51.2631 35.3182 51.2081L53.3768 33.1401C53.485 33.0297 53.5456 32.8813 53.5456 32.7267C53.5456 32.5722 53.485 32.4238 53.3768 32.3134Z",
    fill: "#008850"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSuccessResultBadge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "success-result-badge.81928071eced0bd98da2a6163df6ff97.svg";